defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/ActivityFeed',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/ActivityFeed/NormalCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/ActivityFeed/GameCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
  ],
  function (m, Utils, PostCard, NormalCard, GameCard, CtaButton) {

    // View:
    var ActivityFeed = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.lastFeedTimeISO8601 = m.prop(null);
        this.newsCard = m.prop(null);
      },
      view: function (controller) {
        const activityFeedCards = () => {
          const clubActivityFeed = controller.clubActivityFeed() || [];

          if (clubActivityFeed.length === 0) {
            return m('.play-together-club-activity-feed__empty-list');
          }

          const _normalCardFeedTypes = [
            'GameFunded',
            'GroupCreation',
            'GroupChangeName',
            'GroupChangeTheme',
            'GroupChangeRules',
            'GroupChangeChairman',
            'PlayerJoined',
            'PlayerLeft'
          ];
          const _gameCardFeedTypes = [
            'SubscriptionCreated',
            'SubscriptionJoined',
            'GameFundedSubscription',
            'GameCreated',
            'GameDrawComplete',
            'GameDeleted'
          ];

          return clubActivityFeed.map((feedPost, index) => {
            const feedTypeIsKnown = _normalCardFeedTypes.includes(feedPost.type) || _gameCardFeedTypes.includes(feedPost.type);
            const postWrapper = [];
            const postTimeISO8601 = Utils.parseISO8601(feedPost.timeStamp);
            const now = new Date();
            const nowISO8601 = Utils.parseISO8601(now.toISOString());
            if (!controller.lastFeedTimeISO8601()) {
              controller.lastFeedTimeISO8601(nowISO8601);
            }

            const isNewPostTime = controller.lastFeedTimeISO8601().minutes !== postTimeISO8601.minutes ||
                                  controller.lastFeedTimeISO8601().hours !== postTimeISO8601.hours ||
                                  controller.lastFeedTimeISO8601().date !== postTimeISO8601.date ||
                                  controller.lastFeedTimeISO8601().month !== postTimeISO8601.month ||
                                  controller.lastFeedTimeISO8601().year !== postTimeISO8601.year;

            if (isNewPostTime && feedTypeIsKnown) {
              let displayedTime = `${postTimeISO8601.date}.${postTimeISO8601.monthName.substring(0, 3).toUpperCase()} `;
              if (postTimeISO8601.year !== nowISO8601.year) {
                displayedTime += `${postTimeISO8601.year} `;
              }
              displayedTime += `${postTimeISO8601.hours}:${postTimeISO8601.minutes}`;

              postWrapper.push(m('.play-together-club-activity-feed__timestamp', displayedTime));
              controller.lastFeedTimeISO8601(postTimeISO8601);
            }


            if (_normalCardFeedTypes.includes(feedPost.type)) {
              postWrapper.push(m(NormalCard, { controller, feedPost, index }));
            }
            if (_gameCardFeedTypes.includes(feedPost.type)) {
              postWrapper.push(m(GameCard, { controller, feedPost, index }));
            }
            if (feedPost.type === 'News') {
              const newsProps = {
                type: 'news',
                title: feedPost.message.header,
                description: feedPost.message.message
              };
              if (feedPost.message.callToActionText) {
                newsProps.$footer = CtaButton({
                  text: feedPost.message.callToActionText,
                  href: feedPost.message.callToActionUrl,
                  options: ['primary']
                });
              }
              controller.newsCard(PostCard(newsProps));
            }
            if (!feedTypeIsKnown && feedPost.type !== 'News') {
              console.warn('Unknown activity feed type: ' + feedPost.type);
            }

            return postWrapper;
          });
        };

        // View:
        return m('.play-together-club-activity-feed', [
          controller.viewClubDictionary('ActivityFeed/FeedTitle').length > 0 ? m('.play-together-club-activity-feed__title', controller.viewClubDictionary('ActivityFeed/FeedTitle')) : null,
          controller.newsCard(),
          activityFeedCards(),
          m('.play-together-club-activity__footer', controller.showCreatePlayButton() ? m('.mobile-only', CtaButton({
            text: controller.viewClubDictionary('CreateNewGameButton'),
            href: controller.navigationPaths.createPlayChooseGamePage + '?klubId=' + controller.clubModelFields().clubId(),
            options: ['small']
          })) : null)
        ]);
      }
    };

    // Public functions:
    return ActivityFeed;

  });
